import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" spacing={2} sx={{ py: 10, textAlign: 'center' }}>
      <Box component="img" src="/brand/aiqbee-square.png" alt="" sx={{ width: 72, height: 72, opacity: 0.4 }} />
      <Typography variant="h1">{t('notFound.title')}</Typography>
      <Typography variant="body2" color="text.secondary">
        {t('notFound.description')}
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">{t('notFound.back')}</Button>
    </Stack>
  );
}
